// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@werner/App/Components/Common/XngZone";
import { DivWrapper } from "@werner/XDL/constants";
import { xScreen } from "@werner/XDL/Utilities";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    brandName = "brandName",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.brandName]: string;
    };
}

type Props = OwnProps;

interface BrandDetailsSocialLinksStyles {
    container?: InjectableCss;
    brandName?: TypographyPresentationProps;
    socialLinksWrapper?: InjectableCss;
}

const brandDetailsSocialLinksStyles: BrandDetailsSocialLinksStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            justify-content: center;
            align-items: center;
        `,
    },
    brandName: {
        forwardAs: "h4",
        size: 28,
        lineHeight: "32px",
        weight: 400,
        css: css`
            ${xScreen("lte", "md")} {
                font-size: 24px;
                line-height: 28px;
                weight: 400px;
            }
        `,
    },
    socialLinksWrapper: {
        css: css`
            max-width: 80%;
            width: 100%;
            margin: 0 auto;
        `
    }
};

const BrandDetailsSocialLinks: React.FC<Props> = ({ fields: { brandName }, id }) => {
    const styles = brandDetailsSocialLinksStyles;
    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.brandName}>
                {translate("Connect With")} {brandName}!
            </Typography>
            <StyledWrapper {...styles.socialLinksWrapper}>
                <XngZone zoneName="SocialLinks" contentId={id} hint="Zone For Social Links" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsSocialLinks,
    definition: {
        group: "Xngage Custom" as any,
        displayName: "Shared Social Links",
        icon: "thumbs-up",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.brandName,
                editorTemplate: "TextField",
                displayName: "Brand Name",
                defaultValue: "Brand Name Example",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
